import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Checkbox, Input, Radio } from 'antd';
import PageElementTypeEnum from 'enums/page_element_type.enum';
import ElementActions from 'pages/admin/common/page-elements/types/ElementActions';

const ButtonElement = React.memo(({ id, pageElement, setPageElement, setRefs }) => {
    const { t } = useTranslation();
    return (
        <div className="page-element-block">
            <div className="header pb-24">
                <div className="element-common-heading">{t(`enum:${PageElementTypeEnum.BUTTON.text}`)}</div>
                <ElementActions id={id} />
            </div>
            <div className="element-item">
                <div className="element-item-label">{'ラベル名'}</div>
                <Input
                    value={pageElement.content}
                    onChange={e => {
                        setPageElement({ id, changes: { content: e.target.value } });
                    }}
                    ref={el => setRefs({ id, el: el })}
                />
                <div className="element-item-label mt-24">{'遷移先URL'}</div>
                <Input
                    value={pageElement.media_url}
                    onChange={e => {
                        setPageElement({ id, changes: { media_url: e.target.value, image_media_url: 'false' } });
                    }}
                />
            </div>
            <div>
                <Checkbox
                    className="mt-24"
                    checked={pageElement.is_displayed}
                    onChange={e => {
                        setPageElement({ id, changes: { is_displayed: e.target.checked ? 1 : 0 }});
                    }}
                >
                    {t('Posted in the news')}
                </Checkbox>
            </div>
        </div>
    );
});

export default ButtonElement;

ButtonElement.propTypes = {
    id: PropTypes.any.isRequired,
    pageElement: PropTypes.object,
    setPageElement: PropTypes.func,
};
